import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showOverlay, hideOverlay } from '../actions/overlay';
import Keyboard from '../components/Keyboard';

export class KeyboardContainer extends Component {
  render() {
    return <Keyboard {...this.props} />;
  }
}

export const mapDispatchToProps = dispatch => ({
  showOverlay: data => dispatch(showOverlay(data)),
  hideOverlay: () => dispatch(hideOverlay())
});

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeyboardContainer);
